import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class TodaysAssignmentsService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetAssignments(data) {
        return this.http.post('/api/TodayAssignment/TodaysAssignmentsHomepage', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetTimeSpecificActivities(data) {
        return this.http.post('/api/TodayAssignment/TimeSpecificActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetPreparationItems(data) {
        return this.http.post('/api/TodayAssignment/GetPreparationItems', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomDetails(data) {
        return this.http.post('/api/TodayAssignment/GetRoomGroups', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetGroupActivities(data) {
        return this.http.post('/api/TodayAssignment/GetGroupActivities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetActivityDetails(data) {
        return this.http.post('/api/TodayAssignment/ActivityDetails', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomRackCensus(data) {
        return this.http.post('/api/TodayAssignment/RoomRackCensus', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    StartWorking(data) {
        return this.http.post('/api/TodayAssignment/StartWorkingInRoom', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    MarkComplete(data) {
        return this.http.post('/api/TodayAssignment/MarkActivitiesCompleted', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SaveActivity(data) {
        return this.http.post('/api/TodayAssignment/SaveActivityDetails', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SaveRoomRackCensus(data) {
        return this.http.post('/api/TodayAssignment/SaveRoomRackCensus', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    UpdateRoomNote(data) {
        return this.http.post('/api/TodayAssignment/RoomNoteAction', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    IsRoomStarted(data) {
        return this.http.post('/api/TodayAssignment/RoomIsStarted', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    CompleteTimeSpecificActivity(data) {
        return this.http.post('/api/TodayAssignment/TimeSpecificActivityCompleted', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    UpdateActvityStatus(data) {
        return this.http.post('/api/TodayAssignment/UpdateActvityStatus', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
